import React, { useEffect, useState } from "react";
import { fetchPdfFile } from "./services/fetchPdfFile.service.ts";

interface PdfViewerProps {
  fileUrl?: string;
}

export const PdfViewer: React.FC<PdfViewerProps> = ({ fileUrl }) => {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!fileUrl) return;
    setLoading(true);
    setError(null);

    fetchPdfFile(fileUrl)
      .then(setBlobUrl)
      .catch(() => setError("Failed to load PDF"))
      .finally(() => setLoading(false));

    return () => {
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, [fileUrl]);

  if (loading)
    return (
      <div className="flex h-full w-full items-center justify-center bg-[#262730] text-gray-400">
        Loading PDF…
      </div>
    );

  if (error)
    return (
      <div className="flex h-full w-full items-center justify-center bg-[#262730] text-red-400">
        {error}
      </div>
    );

  if (!blobUrl)
    return (
      <div className="flex h-full w-full items-center justify-center bg-[#262730] text-gray-400">
        No PDF to display
      </div>
    );

  return (
    <iframe
      src={blobUrl}
      title="PDF Viewer"
      className="w-full h-full border-0 bg-[#1a1a1a]"
    />
  );
};
